import React from "react";
import { Search } from "lucide-react";

interface FleetFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export const FleetFilters: React.FC<FleetFiltersProps> = ({
  search,
  onSearchChange,
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <div className="relative max-w-md">
        <label htmlFor="fleet-search" className="sr-only">
          Search fleets by name
        </label>
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          id="fleet-search"
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search fleets by name..."
          className="w-full border border-gray-300 rounded-md pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </div>
  );
};
